import { WSQueryConfig } from "@ws-react-query";
import { getVerificationMissingData } from "../../../services/api/onboarding/missingFields";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSAnalytics } from "../../../utils/WSAnalytics";
import { useWSQuery } from "../../helpers";

export const QUERY_VERIFICATION_MISSING_DATA =
  "QUERY_VERIFICATION_MISSING_DATA";

export const useQueryVerificationMissingData = (
  verificationLevel: Parameters<typeof getVerificationMissingData>[0],
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof getVerificationMissingData>>,
    WSServiceError
  >
) => {
  const analytics = useWSAnalytics();

  return useWSQuery(
    [QUERY_VERIFICATION_MISSING_DATA, verificationLevel],
    async () => {
      const missingData = await getVerificationMissingData(verificationLevel);

      // Track missing data if there are any
      if (
        missingData.requiredFields?.length ||
        missingData.completeOnboardingToken
      ) {
        analytics.track.other("Missing Data Retrieved", {
          verificationLevel,
          requiredFields: missingData.requiredFields,
          requiredDocuments: !!missingData.completeOnboardingToken
        });
      }

      return missingData;
    },
    config
  );
};
